/**
 * Apply To All
 *
 * A small utility function for composing functions that need to be called
 * with the same arguments
 *
 * It accepts any number of functions and returns a single function that accepts any number
 * of arguments and calls each function with the arguments.
 *
 * @module    apply-to-all
 * @author    Frontend Design Systems <FrontendDesignSystems@wayfair.com>
 * @copyright 2019 Wayfair LLC - All rights reserved
 */
const applyToAll = (...functions) => (...args) =>
  functions.forEach((fn) => typeof fn === 'function' && fn(...args));

export default applyToAll;
